export default {
	pt: {
		messages: {
			required: (field) => `O campo ${field.toLowerCase()} é obrigatório.`,
			email: (field) => `O campo ${field.toLowerCase()} não é válido.`,
			authorize: (field) => `Tem que autorizar o campo ${field.toLowerCase()}.`
		}
	}
}


// WEBPACK FOOTER //
// ./src/i18n/vee-validate/vee-validate_pt.js